import '../sass/styles.scss';
window.jQuery = $;
import * as $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
	$('.navbar-toggler').on('click', function () {
		$(this).toggleClass('open');
	});

	$(function ($) {
		const breakpoint = 992;

		$('.menu-item-has-children')
			.on('mouseenter', function () {
				if (window.innerWidth < breakpoint) return;
				$(this).addClass('open').children('.dropdown-menu').stop(true, true).slideDown(200);
			})
			.on('mouseleave', function () {
				if (window.innerWidth < breakpoint) return;
				$(this).removeClass('open').children('.dropdown-menu').stop(true, true).slideUp(200);
			});

		$('.menu-item-has-children > a').each(function () {
			$(this).after('<button class="dropdown-toggle-btn" aria-label="Avaa alavalikko"></button>');
		});

		$('.dropdown-toggle-btn').on('click keydown', function (e) {
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
			if (e.type === 'keydown') e.preventDefault();
			if (e.type === 'click' && window.innerWidth >= breakpoint) return;

			const $parent = $(this).closest('.menu-item-has-children');
			const isOpen = $parent.hasClass('open');

			$parent.toggleClass('open');
			$parent.children('.dropdown-menu').stop(true, true).slideToggle(200);
			$(this).attr('aria-expanded', !isOpen);
		});

		// Sulje alavalikko kun focus poistuu nav-itemistä
		$('.menu-item-has-children').on('focusout', function () {
			const $parent = $(this);
			setTimeout(function () {
				if (!$parent.find(':focus').length) {
					$parent.removeClass('open').children('.dropdown-menu').stop(true, true).slideUp(200);
					$parent.find('.dropdown-toggle-btn').attr('aria-expanded', false);
				}
			}, 100);
		});
	});

	$('.open-search').click(function () {
		$('#search-container').slideToggle(200);
		$('#search-container #search').focus();
	});

	$('.close-search').click(function () {
		$('#search-container').slideUp(200);
	});

	$('.load-more').on('click', function () {
		const button = $(this);
		let paged = button.data('paged');

		$.ajax({
			url: brbrApp.ajaxUrl,
			type: 'GET',
			data: {
				action: 'load_posts',
				paged,
			},
		}).always(function (data) {
			if (data.html) {
				$('.article-list').append(data.html);

				paged++;

				if (data.maxpages <= paged) {
					button.hide();
				} else {
					button.show();
					button.data('page', paged);
				}
			}
		});
	});

	let map = null;
	let markers = [];
	let searchTimeout = null;

// -------------------------
// MAP INIT
// -------------------------
	if ($('#map').length > 0) {

		map = L.map('map');
		map.setView([65.0, 26.0], 6);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap',
		}).addTo(map);

		function initMarkers() {

			$('.kohde-info').each(function () {

				const lat = $(this).data('lat');
				const lng = $(this).data('lng');
				const title = $(this).data('title');
				const url = $(this).data('url');

				if (!lat || !lng) return;

				const popupContent = `
				<div class="map-popup">
					<h4>${title}</h4>
					<a href="${url}">Näytä kohde</a>
				</div>
			`;

				const marker = L.marker([lat, lng])
					.addTo(map)
					.bindPopup(popupContent);

				markers.push({
					el: $(this),
					marker: marker,
					searchText: (
						($(this).data('title') || '') + ' ' +
						($(this).data('city') || '') + ' ' +
						$(this).text()
					).toLowerCase(),
				});
			});
		}

		initMarkers();
	}

// -------------------------
// FILTER (CATEGORY + SEARCH)
// -------------------------
	function filterAll() {

		let selected = [];
		let visibleMarkers = [];

		const searchValue = ($('#map-search').val() || '')
			.toLowerCase()
			.trim();

		$('.cat-selector.selected').each(function () {
			selected.push($(this).data('category'));
		});

		markers.forEach((item) => {

			const cats = (item.el.data('categories') || '')
				.toString()
				.split(' ');

			const categoryMatch =
				selected.length === 0
					? true
					: cats.some(cat => selected.includes(cat));

			const searchMatch =
				searchValue === ''
					? true
					: item.searchText.includes(searchValue);

			const match = categoryMatch && searchMatch;

			if (match) {

				item.el.show();

				if (!map.hasLayer(item.marker)) {
					item.marker.addTo(map);
				}

				visibleMarkers.push(item.marker);

			} else {

				item.el.hide();

				if (map.hasLayer(item.marker)) {
					map.removeLayer(item.marker);
				}
			}
		});

		// zoom logic
		if (visibleMarkers.length > 0) {

			const group = L.featureGroup(visibleMarkers);

			map.fitBounds(group.getBounds(), {
				padding: [50, 50],
				maxZoom: 14,
			});

		} else {

			const finlandBounds = [
				[59.8, 20.2],
				[69.9, 31.2],
			];

			map.fitBounds(finlandBounds, {
				padding: [50, 50],
				maxZoom: 12,
			});
		}

		const noResults = visibleMarkers.length === 0;

		if (noResults) {
			$('#map-no-results').show();
		} else {
			$('#map-no-results').hide();
		}
	}

	// -------------------------
	// CATEGORY CLICK EVENTS (jos käytössä)
	// -------------------------
	$(document).on('click', '.cat-selector', function () {
		let selected = [];
		$('.cat-selector.selected').each(function () {
			selected.push($(this).data('category'));
		});
		filterAll();
	});

	// -------------------------
	// SEARCH INPUT (debounce)
	// -------------------------
	$('#map-search').on('input', function () {
		clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			filterAll();
		}, 200);
	});

/*
	let map = null;
	let markers = [];

	// -------------------------
	// MAP
	// -------------------------
	if ($('#map').length > 0) {
		map = L.map('map');
		map.setView([65.0, 26.0], 6);
		/!*
		const finlandBounds = [
			[59.5, 19.0],
			[70.2, 31.6],
		];

		map.fitBounds(finlandBounds);
		*!/

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap',
		}).addTo(map);

		function initMarkers() {
			$('.kohde-info').each(function () {
				const lat = $(this).data('lat');
				const lng = $(this).data('lng');
				const title = $(this).data('title');
				const url = $(this).data('url');

				if (!lat || !lng) return;

				const popupContent = `
					<div class="map-popup">
						<h4>${title}</h4>

						<a href="${url}">
							Näytä kohde
						</a>
					</div>
				`;

				const marker = L.marker([lat, lng]).addTo(map).bindPopup(popupContent);

				markers.push({
					el: $(this),
					marker: marker,
				});
			});
		}

		initMarkers();
	}
	function filterAll() {
		let selected = [];
		let visibleMarkers = [];

		$('.cat-selector.selected').each(function () {
			selected.push($(this).data('category'));
		});

		// Ei filtteriä -> näytä kaikki
		if (selected.length === 0) {
			$('.kohde-info').show();

			markers.forEach((item) => {
				item.el.show();

				if (!map.hasLayer(item.marker)) {
					item.marker.addTo(map);
				}

				visibleMarkers.push(item.marker);
			});

			// Näytä koko Suomi
			const finlandBounds = [
				[59.8, 20.2],
				[69.9, 31.2],
			];

			map.fitBounds(finlandBounds, {
				padding: [50, 50],
				maxZoom: 12,
			});

			return;
		}

		// Filteröinti
		markers.forEach((item) => {
			const cats = item.el.data('categories').toString().split(' ');

			const match = cats.some((cat) => selected.includes(cat));

			if (match) {
				item.el.show();

				if (!map.hasLayer(item.marker)) {
					item.marker.addTo(map);
				}

				visibleMarkers.push(item.marker);
			} else {
				item.el.hide();

				if (map.hasLayer(item.marker)) {
					map.removeLayer(item.marker);
				}
			}
		});

		// Zoomaa näkyviin markereihin
		if (visibleMarkers.length > 0) {
			const group = L.featureGroup(visibleMarkers);

			map.fitBounds(group.getBounds(), {
				padding: [50, 50],
				maxZoom: 14,
			});
			let map = null;
			let markers = [];

			// -------------------------
			// MAP
			// -------------------------
			if ($('#map').length > 0) {
				map = L.map('map');
				map.setView([65.0, 26.0], 6);
				/!*
				const finlandBounds = [
					[59.5, 19.0],
					[70.2, 31.6],
				];

				map.fitBounds(finlandBounds);
				*!/

				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; OpenStreetMap',
				}).addTo(map);

				function initMarkers() {
					$('.kohde-info').each(function () {
						const lat = $(this).data('lat');
						const lng = $(this).data('lng');
						const title = $(this).data('title');
						const url = $(this).data('url');

						if (!lat || !lng) return;

						const popupContent = `
					<div class="map-popup">
						<h4>${title}</h4>

						<a href="${url}">
							Näytä kohde
						</a>
					</div>
				`;

						const marker = L.marker([lat, lng]).addTo(map).bindPopup(popupContent);

						markers.push({
							el: $(this),
							marker: marker,
							searchText: (
								($(this).data('title') || '') + ' ' +
								($(this).data('city') || '') + ' ' +
								$(this).text()
							).toLowerCase(),
						});
					});
				}

				initMarkers();
			}
			function filterAll() {

				let selected = [];
				let visibleMarkers = [];

				const searchValue = $('#map-search')
					.val()
					.toLowerCase()
					.trim();

				$('.cat-selector.selected').each(function () {
					selected.push($(this).data('category'));
				});

				markers.forEach((item) => {

					const cats = item.el
						.data('categories')
						.toString()
						.split(' ');

					// category match
					const categoryMatch =
						selected.length === 0
							? true
							: cats.some((cat) =>
								selected.includes(cat)
							);

					// search match
					const searchMatch =
						searchValue === ''
							? true
							: item.searchText.includes(searchValue);

					const match =
						categoryMatch && searchMatch;

					if (match) {

						item.el.show();

						if (!map.hasLayer(item.marker)) {
							item.marker.addTo(map);
						}

						visibleMarkers.push(item.marker);

					} else {

						item.el.hide();

						if (map.hasLayer(item.marker)) {
							map.removeLayer(item.marker);
						}
					}
				});

				// näkyviä löytyy → fit bounds
				if (visibleMarkers.length > 0) {

					const group =
						L.featureGroup(visibleMarkers);

					map.fitBounds(group.getBounds(), {
						padding: [50, 50],
						maxZoom: 14,
					});

				} else {

					// fallback Finland
					const finlandBounds = [
						[59.8, 20.2],
						[69.9, 31.2],
					];

					map.fitBounds(finlandBounds, {
						padding: [50, 50],
						maxZoom: 12,
					});
				}
			}

				// Filteröinti
				markers.forEach((item) => {
					const cats = item.el.data('categories').toString().split(' ');

					const match = cats.some((cat) => selected.includes(cat));

					if (match) {
						item.el.show();

						if (!map.hasLayer(item.marker)) {
							item.marker.addTo(map);
						}

						visibleMarkers.push(item.marker);
					} else {
						item.el.hide();

						if (map.hasLayer(item.marker)) {
							map.removeLayer(item.marker);
						}
					}
				});

				// Zoomaa näkyviin markereihin
				if (visibleMarkers.length > 0) {
					const group = L.featureGroup(visibleMarkers);

					map.fitBounds(group.getBounds(), {
						padding: [50, 50],
						maxZoom: 14,
					});
				}
			}

		}



let searchTimeout;

$('#map-search').on('input', function () {

	clearTimeout(searchTimeout);

	searchTimeout = setTimeout(() => {
		filterAll();
	}, 200);

});*/

	$('.cat-selector').on('click', function (e) {
		e.preventDefault();

		$(this).toggleClass('selected');
		$(this).find('input').prop('checked', $(this).hasClass('selected'));
		filterAll();
	});

	// -------------------------
	// TAPAHTUMAT
	// -------------------------
	const filters = document.querySelectorAll('.tapahtuma-filter');
	const results = document.getElementById('tapahtumat-results');

	// filters.forEach((filter) => {
	// 	filter.addEventListener('change', fetchResults);
	// 	console.log(filter);
	// });

	let timeoutTapahtumat;

	filters.forEach((filter) => {
		const eventType = filter.type === 'search' ? 'input' : 'change';

		filter.addEventListener(eventType, function () {
			clearTimeout(timeoutTapahtumat);

			timeoutTapahtumat = setTimeout(fetchResults, 300);
		});
	});

	function fetchResults() {

		const kohderyhma =
			document.getElementById('kohderyhma')?.value || '';

		const tapahtumatyyppi =
			document.getElementById('tapahtumatyyppi')?.value || '';

		const search =
			document.getElementById('tapahtuma-search')?.value || '';

		const formData = new FormData();

		formData.append('action', 'filter_tapahtumat');
		formData.append('kohderyhma', kohderyhma);
		formData.append('tapahtumatyyppi', tapahtumatyyppi);
		formData.append('search', search);

		results.style.opacity = '.5';

		fetch(brbrApp.ajaxUrl, {
			method: 'POST',
			body: formData
		})
			.then(response => response.text())
			.then(html => {

				results.innerHTML = html;
				results.style.opacity = '1';

			});
	}
});
